"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("@emotion/native"));
var button_1 = __importDefault(require("./button"));
var constants_1 = require("./constants");
var Container = native_1.default.View(function (_a) {
    var theme = _a.theme;
    return ({
        flexDirection: 'row',
        paddingHorizontal: 8,
        backgroundColor: theme.backgroundColor || 'white',
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: theme.borderColor || '#e6e6e6',
    });
});
var Bar = /** @class */ (function (_super) {
    __extends(Bar, _super);
    function Bar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Bar.prototype.render = function () {
        var _a = this.props, index = _a.index, onPress = _a.onPress;
        return (react_1.default.createElement(Container, null,
            react_1.default.createElement(button_1.default, { onPress: onPress, testID: "BottomMenu.Navigator", id: constants_1.NAVIGATOR, active: index === constants_1.NAVIGATOR }, "NAVIGATOR"),
            react_1.default.createElement(button_1.default, { onPress: onPress, testID: "BottomMenu.Preview", id: constants_1.PREVIEW, active: index === constants_1.PREVIEW }, "PREVIEW"),
            react_1.default.createElement(button_1.default, { onPress: onPress, testID: "BottomMenu.Addons", id: constants_1.ADDONS, active: index === constants_1.ADDONS }, "ADDONS")));
    };
    return Bar;
}(react_1.PureComponent));
exports.default = Bar;
